export var AppointmentStatus;
(function (AppointmentStatus) {
    AppointmentStatus["SCHEDULED"] = "SCHEDULED";
    AppointmentStatus["CONFIRMED"] = "CONFIRMED";
    AppointmentStatus["AWAITING_CONFIRMATION"] = "AWAITING_CONFIRMATION";
    /**
     * AWAITING_CONFIRMATION older than the 72h confirmation window — never
     * confirmed by the therapist. Non-terminal: `confirm()` is still accepted
     * (backdated delivery still works), but the appointment surfaces as a
     * review task. Lapsing never decides an outcome or creates a fee.
     * (TM-9064 slice 6 / #854.)
     */
    AppointmentStatus["LAPSED"] = "LAPSED";
    AppointmentStatus["CANCELLED"] = "CANCELLED";
    AppointmentStatus["COMPLETED"] = "COMPLETED";
    AppointmentStatus["NO_SHOW"] = "NO_SHOW";
})(AppointmentStatus || (AppointmentStatus = {}));
//# sourceMappingURL=appointment-status.enum.js.map